export const environment = {
    production: true,
    apiUrl: 'https://staffit.alwaysdata.net/api'
  };
  